const mockResponse = {
  data: {
    data: [],
    dataSource: [],
  },
};
export default mockResponse;
